// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__2mE65","fileBtn":"File_fileBtn__1ZKtw","closeBtn":"File_closeBtn__2PJFZ","fileSelected":"File_fileSelected__32Xh0","disabled":"File_disabled__2ElAX"};